import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { FloatingCanvas } from './FloatingCanvas';
export function Hero() {
  const [isFocused, setIsFocused] = useState(false);
  const [prompt, setPrompt] = useState('');
  return <main className="relative min-h-screen pt-24 pb-16 flex flex-col items-center justify-center overflow-hidden" style={{
    background: 'radial-gradient(circle at 50% 40%, #eafaf0, #eef4ff 40%, #ffffff 75%)'
  }} data-id="element-16">
      {/* Drifting "generated UI" cards — an out-of-focus design canvas behind the content */}
      <FloatingCanvas data-id="element-17" />

      {/* Content scrim — a white box that fades the colorful strands out as they
                                  approach the content, keeping text legible and framing the center.
                                  Fully white at the middle, fading linearly to transparent at its edges
                                  so the strands stay vivid out toward the screen edges. */}
      <div aria-hidden="true" className="absolute left-1/2 top-1/2 z-[5] -translate-x-1/2 -translate-y-1/2 pointer-events-none" style={{
      width: 'min(64rem, 94vw)',
      height: 'min(40rem, 82vh)',
      backgroundColor: '#ffffff',
      opacity: 0.92,
      WebkitMaskImage: 'radial-gradient(ellipse at center, #000 30%, transparent 72%)',
      maskImage: 'radial-gradient(ellipse at center, #000 30%, transparent 72%)'
    }} data-id="element-18" />

      {/* Content Container */}
      <div className="relative z-10 w-full max-w-3xl mx-auto px-6 flex flex-col items-center text-center" data-id="element-19">
        {/* Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} className="text-[2rem] md:text-[2.75rem] font-semibold tracking-tight text-gray-900 leading-[1.1]" style={{
        fontFamily: "'Poppins', sans-serif"
      }} data-id="element-20">
          Build the best version <br data-id="element-21" />
          of your product.
        </motion.h1>

        {/* Prompt Box Area */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: 'easeOut'
      }} className="w-full max-w-xl mx-auto mt-9 relative" data-id="element-22">
          {/* Subtle animated glow behind the prompt box */}
          <div className={`absolute -inset-1.5 bg-gradient-to-r from-emerald-200/50 via-blue-200/50 to-purple-200/50 rounded-[1.5rem] blur-xl transition-opacity duration-700 ${isFocused ? 'opacity-100' : 'opacity-0'}`} data-id="element-23" />

          <div className={`relative bg-white rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.06)] border transition-all duration-300 ${isFocused ? 'border-gray-300 ring-4 ring-gray-100/50 shadow-[0_20px_40px_-15px_rgba(0,0,0,0.12)]' : 'border-gray-200'}`} data-id="element-24">
            <textarea value={prompt} onChange={e => setPrompt(e.target.value)} onFocus={() => setIsFocused(true)} onBlur={() => setIsFocused(false)} placeholder="Describe the app or feature you want to build..." className="w-full h-24 md:h-28 bg-transparent border-none focus:ring-0 resize-none p-4 text-base text-gray-800 placeholder-gray-400 outline-none rounded-2xl" data-id="element-25" />

            <div className="absolute bottom-3 right-3" data-id="element-26">
              <button className={`px-4 py-2 rounded-lg text-sm font-medium flex items-center gap-1.5 transition-all duration-200 ${prompt.length > 0 ? 'bg-[#0F172A] hover:bg-black text-white shadow-md hover:shadow-lg transform hover:-translate-y-0.5' : 'bg-[#8E95A3] hover:bg-gray-500 text-white'}`} data-id="element-27">
                Build it <ArrowRight className="w-3.5 h-3.5" data-id="element-28" />
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </main>;
}